<p>You've been inactive for a while. For your security, we'll log you out automatically.</p>
<p>
  Your session will expire in <span class="counter">{{ counter }}</span> seconds.
</p>
